import React from 'react';
import Carousel from 'react-material-ui-carousel';
import CustomerSubHeaderDetails from './CustomerSubHeaderDetails';
import CustomerEmergency from './CustomerEmergency';
import SubHeaderDetails from 'components/subHeaderDetails/SubHeaderDetails';
import { Grid, Paper } from '@mui/material';

function CustomerCarousel(props) {
  const emergencyContactsLength = props?.details?.EmergencyContacts?.length > 3

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="space-around"
      alignItems="flex-start"
      className="customerCarousel"
      sm={12}
      md={3.3}
    >
      <Grid sm={12} md={12} className='width100'>
        {emergencyContactsLength ? 
          <Carousel>
            {props?.type == 'Driver' ? <Paper>
              <SubHeaderDetails details={props?.details} loader={props?.loader}/>
            </Paper> : 
            <Paper className='border_box_shadow'>
              <CustomerSubHeaderDetails details={props?.details} loader={props?.loader}/>
            </Paper>}
            <Paper className='border_box_shadow'>
              <CustomerEmergency details={props?.details} first3={true} />
            </Paper>
            <Paper className='border_box_shadow'>
              <CustomerEmergency details={props?.details} last2={true} />
            </Paper>
          </Carousel>
          : props?.details?.EmergencyContacts?.length > 0 ? (
          <Carousel>
            {props?.type == 'Driver' ? <Paper>
              <SubHeaderDetails details={props?.details} type={props?.type} onSubmittBtn={props?.onSubmittBtn} editData={props.editData} loader={props?.loader}/>
            </Paper> : 
            <Paper className='border_box_shadow'>
              <CustomerSubHeaderDetails details={props?.details} loader={props?.loader}/>
            </Paper>}
            <Paper className='border_box_shadow'>
              <CustomerEmergency details={props?.details} first3={true} loader={props?.loader}/>
            </Paper>
          </Carousel>)
          : (
            
            <Paper>
              {props?.type == 'Driver' ? 
              <SubHeaderDetails details={props?.details} type={props?.type} onSubmittBtn={props?.onSubmittBtn} editData={props.editData} loader={props?.loader}/>: 
              <CustomerSubHeaderDetails details={props?.details} loader={props?.loader} />}
            </Paper>
          )
        }
      </Grid>
    </Grid>
  );
}

export default CustomerCarousel;
